export const METRICS_JS_COUNTERS = {
  checkout_session_loaded: 'checkout_session_loaded',
  checkout_page_interaction: 'checkout_page_interaction',
  error_boundary_triggered: 'error_boundary_triggered',
  stripe_payment_element_onload_error: 'stripe_payment_element_onload_error',
  successful_checkout_submission: 'successful_checkout_submission'
};